import { useState } from "react";
import { PageShell, PageHero } from "@/components/PageShell";
import { Reveal } from "@/components/Reveal";
import { assetUrl } from "@/lib/api";

// Structure prête pour plus tard : avant/après, localisation, surface, contexte,
// besoin client, solutions, travaux réalisés, durée, photos, témoignage.
// Tant que les vraies réalisations CozyHome ne sont pas fournies : inspirations.
const CATEGORIES = ["Tous", "Rénovation", "Extension", "Aménagement intérieur", "Construction"];

const PROJECTS = [
  { title: "Maison ouverte sur le jardin", category: "Rénovation",
    img: "https://images.unsplash.com/photo-1628745277862-bc0b2d68c50c?crop=entropy&cs=srgb&fm=jpg&q=85", span: "md:col-span-7" },
  { title: "Le charme de l'ancien, autrement", category: "Rénovation",
    img: "https://images.unsplash.com/photo-1758448755969-8791367cf5c5?crop=entropy&cs=srgb&fm=jpg&q=85", span: "md:col-span-5" },
  { title: "Une cuisine au cœur de la maison", category: "Aménagement intérieur",
    img: "https://images.unsplash.com/photo-1661107259637-4e1c55462428?crop=entropy&cs=srgb&fm=jpg&q=85", span: "md:col-span-5" },
  { title: "Gagner de l'espace naturellement", category: "Extension",
    img: "https://images.unsplash.com/photo-1628744876497-eb30460be9f6?crop=entropy&cs=srgb&fm=jpg&q=85", span: "md:col-span-7" },
  { title: "Des volumes simples et lumineux", category: "Construction",
    img: assetUrl("/api/static/models/epure.webp"), span: "md:col-span-7" },
  { title: "Créer une vraie suite parentale", category: "Aménagement intérieur",
    img: assetUrl("/api/static/models/canopee-int1.webp"), span: "md:col-span-5" },
];

export default function RealisationsPage() {
  const [cat, setCat] = useState("Tous");
  const visible = cat === "Tous" ? PROJECTS : PROJECTS.filter((p) => p.category === cat);

  return (
    <PageShell>
      <PageHero
        testid="page-realisations-hero"
        label="Inspirations & projets"
        title={<>Imaginez ce que votre espace <span className="italic text-sage">pourrait devenir.</span></>}
        sub="Une pièce plus lumineuse. Une circulation repensée. Quelques mètres carrés supplémentaires. Une maison entièrement transformée. Découvrez différentes inspirations pour commencer à imaginer votre propre projet."
      />

      <section className="bg-ivory pb-20 sm:pb-28">
        <div className="mx-auto max-w-7xl px-5 sm:px-8">
          <div className="flex flex-wrap gap-2.5">
            {CATEGORIES.map((c) => (
              <button
                key={c}
                data-testid={`realisation-filter-${c.toLowerCase().replace(/\s/g, "-")}`}
                onClick={() => setCat(c)}
                className={`rounded-full border-2 px-5 py-2.5 text-sm font-bold transition-colors duration-300 ${
                  cat === c
                    ? "border-cognac bg-cognac text-white"
                    : "border-[#EDEAE3] bg-white text-navy hover:border-cognac/50"
                }`}
              >
                {c}
              </button>
            ))}
          </div>

          <div className="mt-12 grid grid-cols-1 gap-6 md:grid-cols-12">
            {visible.map((p, i) => (
              <Reveal key={p.title} delay={(i % 2) * 0.08} className={`col-span-1 ${p.span}`}>
                <figure
                  data-testid={`realisation-card-${i}`}
                  className="group relative overflow-hidden rounded-3xl"
                >
                  <img
                    src={p.img}
                    alt={p.title}
                    loading={i === 0 ? "eager" : "lazy"}
                    fetchPriority={i === 0 ? "high" : "auto"}
                    decoding="async"
                    className="aspect-[16/10] w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
                  />
                  <span className="absolute inset-0 bg-gradient-to-t from-navy/60 via-transparent to-transparent" />
                  <span className="absolute left-5 top-5 rounded-full bg-white/85 px-3 py-1 text-[11px] font-bold uppercase tracking-wider text-navy backdrop-blur-sm">
                    {p.category} · Inspiration
                  </span>
                  <figcaption className="absolute inset-x-5 bottom-5">
                    <span className="font-display text-xl font-medium text-white sm:text-2xl">{p.title}</span>
                  </figcaption>
                </figure>
              </Reveal>
            ))}
          </div>

          <p data-testid="realisations-demo-note" className="mt-8 rounded-2xl border border-wood/40 bg-cream px-5 py-4 text-xs leading-relaxed text-stone-500 sm:text-sm">
            Les visuels présentés dans cette galerie sont des inspirations. Les
            réalisations CozyHome seront ajoutées progressivement.
          </p>
        </div>
      </section>
    </PageShell>
  );
}
